import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Project } from 'src/app/models/project.model';
import { AuthService } from 'src/app/services/auth.service';
import { RequestService } from 'src/app/services/request.service';
import { take, takeUntil } from 'rxjs/operators';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';
import { ModalDialog } from 'src/app/Modal/modal';
import { WaitForModalResult } from 'src/app/helper/modalHelper';
import { Region } from 'src/app/models/region.model';
import { GraphicSettings } from 'src/app/models/GraphicSettings.model';
import { Graphic } from 'src/app/models/graphic.model';
import { VariantEvaluationViewParameters } from 'src/app/models/VariantEvaluationViewParameters.model';
import { TrainVariantDoorForCheckList } from "src/app/models/TrainVariantDoorForCheckList";
import { SelectableArea, TrainAndDoorsForChecklist } from "src/app/models/TrainAndDoorsForChecklist";
import { IdentificationComponent } from 'src/app/models/components/commonComponents/IdentificationComponent';
import { TrainEvaluationParameters } from 'src/app/models/TrainAndDoorList.model';
import { TrainEvaluationService } from '../TrainEvaluation.service';
import { downloadFile, getCheckedState, getIntermediateState, indexOfField } from '../EvaluationHelper';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-evaluation-train',
  templateUrl: './evaluation-train.component.html',
  styleUrls: ['./evaluation-train.component.scss'],
  providers: [TrainEvaluationService]
})
export class EvaluationTrainComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  private backButtonModalMessage: string = "Are your sure that you want to leave the analysis?";
  private companyId: number;

  public projects: Project[];
  public selectedProjectID: number;
  public trainsAndDoorsForChecklist: TrainAndDoorsForChecklist[];
  public trainMissingConfigurationInfo: string = "This train hastn't been configured yet";
  public trainDeletedVariantsInfo: string = "This train has deleted variants in the configuration";
  public collidingObjectErrorInfo: string = "This door belongs to a variant with colliding objects. Be aware that you might start the analysis, but it will fail until the colliding object issue is resolved.";
  public projectDropdownTitle = "Choose a project";
  public analyseButtonText = "Analyse";
  public tabTravelmixTitle = "Travelmix";
  public tabGraphicsTitle = "Graphics";
  public tabTrainsTitle = "Trains";
  public tabAdvancedSettingsTitle = "Advanced settings";
  public trainsUnavailableText = "This project has no available trains, please choose a other project";
  public projectUnavailableText = "Please select a project to see selectable trains";
  public anySelectedTrainHasSecondDeck: boolean;
  public luggageCalculationInputSource = [{ Value: 1, Name: 'Analyse across decks' }, { Value: 2, Name: 'Analyse decks separate' }];
  public graphicSelectionTitel = 'Graphic selection';

  public get considerAllDecksForCalculation() {
    if (this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation) {
      return this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation;
    }
    return undefined;
  }

  public get passengerAlgorithmGraphicSelected() {
    if (this.evaluationService.passengerAlgorithmGraphicSelected.value) {
      return this.evaluationService.passengerAlgorithmGraphicSelected.value;
    }
    return undefined;
  }

  constructor(private requestService: RequestService,
    private dialog: MatDialog,
    private authService: AuthService,
    public evaluationService: TrainEvaluationService) {
    this.companyId = this.authService.getCurrentCompanyId();
  }

  ngOnInit() {
    this.evaluationService.initializeEvaluationFrontendParameter();
    this.loadProjects();
    this.loadRegions(this.companyId);
    this.loadGraphics(this.companyId);
    this.loadMasterData();

    this.evaluationService.project
      .pipe(takeUntil(this.destroy$))
      .subscribe(next => {
        if (next != null && next.id > 0) {
          this.requestService.getTrainsForEvaluation(next.id)
            .pipe(takeUntil(this.destroy$))
            .subscribe(trains => {
              if (trains) {
                this.mapTrainsForChecklist(trains);
              }
              else {
                this.trainsAndDoorsForChecklist = [];
              }
              this.anySelectedTrainHasSecondDeck = false;
              this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation = false;
            });
        }
      });

    // this.evaluationService.passengerAlgorithmGraphicSelected
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(passengerAlgorithmGraphicSelected => {
    //     if (passengerAlgorithmGraphicSelected && this.evaluationService.evaluationFrontEndParameter.trainAndDoorList && this.evaluationService.evaluationFrontEndParameter.trainAndDoorList.length > 0) {
    //       this.evaluationService.evaluationFrontEndParameter.trainAndDoorList.forEach(train => {
    //         let tmp = this.trainsAndDoorsForChecklist.find(x => x.id == train.id);
    //         if (tmp && tmp.isSelected && !tmp.doors) {
    //           this.loadDoors(tmp, tmp.isSelected);
    //         }
    //       })
    //     }
    //   });
  }

  debug() {
    console.log("Debug component: ", this);
  }

  // loadDoors(train: TrainAndDoorsForChecklist, status) {
  //   if (status) {
  //     if (!train.doors && this.evaluationService.passengerAlgorithmGraphicSelected.value) {
  //       this.requestService.GetVariantsWithDoorsFromTrain(train.id)
  //         .pipe(takeUntil(this.destroy$))
  //         .subscribe((variantsWithDoors: VariantEvaluationViewParameters[]) => {
  //           train.doors = this.mapTrainVariantDoorsForChecklist(variantsWithDoors);
  //         });
  //     }
  //   }
  // }
  loadDoors(train: TrainAndDoorsForChecklist, status) {
    if (status) {
      if (!train.doors) {
        this.requestService.GetVariantsWithDoorsFromTrain(train.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe((variantEvaluationviewParameters: VariantEvaluationViewParameters[]) => {
            train.doors = this.mapTrainVariantDoorsForChecklist(variantEvaluationviewParameters);
            this.mapSelectableAreas(variantEvaluationviewParameters, train);
          });
      }
    }
  }

  loadProjects() {
    this.requestService.getProjects(this.companyId)
      .pipe(take(1))
      .subscribe(resp => {
        resp.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
        this.projects = resp;
      });
  }

  loadMasterData() {
    this.requestService.getMasterData()
      .pipe(takeUntil(this.destroy$))
      .subscribe(masterData => {
        masterData.comfortTypeList.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
        this.evaluationService.comfortValues = masterData.comfortTypeList;
        masterData.transportModeList.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
        this.evaluationService.transportModes = masterData.transportModeList;
        this.evaluationService.allGraphics = masterData.graphicList;
      });
  }

  loadRegions(companyId: number): any {
    this.requestService.getCompanyRegions(companyId)
      .pipe(take(1))
      .subscribe((resp: Region[]) => {
        resp.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
        this.evaluationService.regions = resp;
      });
  }

  loadGraphics(companyId: number) {
    this.requestService.getGraphicSettings(companyId)
      .pipe(take(1))
      .subscribe((resp: GraphicSettings) => {
        if (resp) {
          this.evaluationService.companyGraphicSettings = resp;
        }
        else {
          console.error("No graphics available, defaulting to empty graphics array!");
          this.evaluationService.companyGraphicSettings = new GraphicSettings();
          this.evaluationService.companyGraphicSettings.settings = new Array<Graphic>();
        }
      });
  }

  mapTrainsForChecklist(trains: any[]) {
    this.trainsAndDoorsForChecklist = null;

    if (trains != null) {
      this.trainsAndDoorsForChecklist = new Array<TrainAndDoorsForChecklist>();

      for (let index = 0; index < trains.length; index++) {
        const train = trains[index];
        let tadfc: TrainAndDoorsForChecklist = new TrainAndDoorsForChecklist();
        tadfc.isSelected = false;
        tadfc.id = train.id;
        tadfc.name = train.name;
        tadfc.hasTrainConfiguration = train.hasTrainConfiguration;
        tadfc.hasDeletedVariants = train.hasDeletedVariants;
        tadfc.hasSecondDeck = train.hasSecondDeck;
        this.trainsAndDoorsForChecklist.push(tadfc);
      }
      // sort variants after mapping finished
      this.trainsAndDoorsForChecklist.sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));
    }
  }

  mapTrainVariantDoorsForChecklist(trainVariantsWithDoors: VariantEvaluationViewParameters[]): TrainVariantDoorForCheckList[] {
    let trainVariantsForCheckList: TrainVariantDoorForCheckList[] = new Array<TrainVariantDoorForCheckList>();

    for (let trainVariantWithDoorsIndex = 0; trainVariantWithDoorsIndex < trainVariantsWithDoors.length; trainVariantWithDoorsIndex++) {
      const currentTrainVariantWithDoors = trainVariantsWithDoors[trainVariantWithDoorsIndex];
      currentTrainVariantWithDoors.doors.sort((a, b) => dynamicLocaleCompareWithOptions(a.doorIdentificationComponent, b.doorIdentificationComponent, 'userId'));

      for (let trainVariantDoorIndex = 0; trainVariantDoorIndex < currentTrainVariantWithDoors.doors.length; trainVariantDoorIndex++) {
        const currentTrainVariantDoor = currentTrainVariantWithDoors.doors[trainVariantDoorIndex];

        let trainVariantDoorForChecklist = new TrainVariantDoorForCheckList();
        trainVariantDoorForChecklist.id = currentTrainVariantWithDoors.id;
        trainVariantDoorForChecklist.name = currentTrainVariantWithDoors.name;
        trainVariantDoorForChecklist.isSelected = false;
        trainVariantDoorForChecklist.hasCollissions = currentTrainVariantWithDoors.hasCollissions;
        trainVariantDoorForChecklist.identificationComponent = new IdentificationComponent();
        trainVariantDoorForChecklist.identificationComponent.id = currentTrainVariantDoor.doorIdentificationComponent.id;
        trainVariantDoorForChecklist.identificationComponent.userId = currentTrainVariantDoor.doorIdentificationComponent.userId;
        trainVariantDoorForChecklist.isUpperDoor = currentTrainVariantDoor.isUpperDoor;


        trainVariantsForCheckList.push(trainVariantDoorForChecklist);
      }
    }

    return trainVariantsForCheckList;
  }

  mapSelectableAreas(variantEvaluationViewParameters: VariantEvaluationViewParameters[], train: TrainAndDoorsForChecklist) {
    let acrossDeckAreaSelection: SelectableArea[] = [];
    let separatDeckAreaSelection: SelectableArea[] = [];

    for (let variantEvaluationViewParameterIndex = 0; variantEvaluationViewParameterIndex < variantEvaluationViewParameters.length; variantEvaluationViewParameterIndex++) {
      const currentVariantEvaluationViewParameter = variantEvaluationViewParameters[variantEvaluationViewParameterIndex];

      for (let selectableAreaIndex = 0; selectableAreaIndex < currentVariantEvaluationViewParameter.acrossDeckAreaSelection.length; selectableAreaIndex++) {
        const currentSelectableAreaName = currentVariantEvaluationViewParameter.acrossDeckAreaSelection[selectableAreaIndex];

        let selectableArea = new SelectableArea();
        selectableArea.isSelected = false;
        selectableArea.name = currentSelectableAreaName;

        acrossDeckAreaSelection.push(selectableArea);
      }

      for (let selectableAreaIndex = 0; selectableAreaIndex < currentVariantEvaluationViewParameter.separatDeckAreaSelection.length; selectableAreaIndex++) {
        const currentSelectableAreaName = currentVariantEvaluationViewParameter.separatDeckAreaSelection[selectableAreaIndex];

        let selectableArea = new SelectableArea();
        selectableArea.isSelected = false;
        selectableArea.name = currentSelectableAreaName;

        separatDeckAreaSelection.push(selectableArea);
      }
    }

    train.acrossDeckAreaSelection = acrossDeckAreaSelection;
    train.separatDeckAreaSelection = separatDeckAreaSelection;
  }

  updateChild(train: TrainAndDoorsForChecklist, status) {
    if (!status) {
      if (train.doors) {
        for (let doorIndex = 0; doorIndex < train.doors.length; doorIndex++) {
          const door = train.doors[doorIndex];
          door.isSelected = train.isSelected;
        }
      }
      if (this.considerAllDecksForCalculation) {
        if (train.acrossDeckAreaSelection) {
          for (let areaIndex = 0; areaIndex < train.acrossDeckAreaSelection.length; areaIndex++) {
            const area = train.acrossDeckAreaSelection[areaIndex];
            area.isSelected = train.isSelected;
          }
        }
      }
      else {
        if (train.separatDeckAreaSelection) {
          for (let areaIndex = 0; areaIndex < train.separatDeckAreaSelection.length; areaIndex++) {
            const area = train.separatDeckAreaSelection[areaIndex];
            area.isSelected = train.isSelected;
          }
        }
      }
      let selectedTrainIndex = indexOfField(this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters, 'id', train.id);
      this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.splice(selectedTrainIndex, 1);
    }
    else {
      let newSelectedTrain = new TrainEvaluationParameters();
      newSelectedTrain.id = train.id;
      newSelectedTrain.doors = new Array<IdentificationComponent>();

      this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.push(newSelectedTrain);
    }

    if (this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.length === 0) {
      this.anySelectedTrainHasSecondDeck = false;
      this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation = false;
    }
    else {
      for (let index = 0; index < this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.length; index++) {
        const selectedTrain = this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters[index];
        const train = this.trainsAndDoorsForChecklist.find(o => o.id === selectedTrain.id);
        if (train.hasSecondDeck) {
          this.anySelectedTrainHasSecondDeck = true;
          break;
        }
      }
    }
  }

  syncTrainParamObject(train: TrainAndDoorsForChecklist) {
    let trainIndex = indexOfField(this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters, 'id', train.id);
    const selectedTrain = this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters[trainIndex];
    selectedTrain.doors = [];

    train.doors.forEach(door => {
      if (door.isSelected) {
        let identificationComponent = new IdentificationComponent();
        identificationComponent.id = door.identificationComponent.id;
        identificationComponent.userId = door.identificationComponent.userId;

        selectedTrain.doors.push(identificationComponent);
      }
    });
  }

  syncSelectableArea(train: TrainAndDoorsForChecklist) {
    let selectedAreaNames;

    let trainIndex = indexOfField(this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters, 'id', train.id);
    const currentTrain = this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters[trainIndex];
    currentTrain.areaSelection = [];
    if (this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation) {
      selectedAreaNames = train.acrossDeckAreaSelection.filter(x => x.isSelected).map(x => x.name);
      currentTrain.areaSelection = selectedAreaNames;
      return;
    }

    selectedAreaNames = train.separatDeckAreaSelection.filter(x => x.isSelected).map(x => x.name);
    currentTrain.areaSelection = selectedAreaNames;
  }

  changeLuggageCalculationInput(value) {
    this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.forEach(x => {
      x.areaSelection = [];
    });

    if (value == 1) {
      this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation = true;
      this.trainsAndDoorsForChecklist.forEach(train => {
        train.separatDeckAreaSelection.forEach(area => {
          area.isSelected = false;
        });
      });
    } else if (value == 2) {
      this.evaluationService.evaluationFrontEndParameter.considerAllDecksForCalculation = false;
      this.trainsAndDoorsForChecklist.forEach(train => {
        train.acrossDeckAreaSelection.forEach(area => {
          area.isSelected = false;
        });
      });
    }
  }

  setDoorsSelectedState(train: TrainAndDoorsForChecklist, upperDoor: boolean, checkedStatus: boolean) {
    train.doors.forEach(door => {
      if (door.isUpperDoor && upperDoor) {
        door.isSelected = checkedStatus;
      }
      else if (!door.isUpperDoor && !upperDoor) {
        door.isSelected = checkedStatus;
      }
    });
    this.syncTrainParamObject(train);
  }

  public getCheckedState(doors: TrainVariantDoorForCheckList[], upperDoor: boolean) {
    return getCheckedState(doors, upperDoor);
  }

  public getIntermediateState(doors: TrainVariantDoorForCheckList[], upperDoor: boolean) {
    return getIntermediateState(doors, upperDoor);
  }

  changeProjectValue(value) {
    if (value !== undefined) {
      const project = this.projects.find(p => p.id == value);
      this.evaluationService.project.next(project);
      this.selectedProjectID = value;
    } else {
      this.evaluationService.project.next(null);
      this.trainsAndDoorsForChecklist = null;
      this.selectedProjectID = null;
    }
    this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters = [];
  }

  validateParameters(): boolean {
    let disabled = false;

    if (this.evaluationService.evaluationFrontEndParameter.projectId == undefined || this.evaluationService.evaluationFrontEndParameter.projectId == null || this.evaluationService.evaluationFrontEndParameter.projectId < 1) {
      return true;
    }

    // travel mix list has to have at least one entry, if there should be a restriction for total travel mixes this has to be added.
    if (this.evaluationService.evaluationFrontEndParameter.travelMixList == undefined || this.evaluationService.evaluationFrontEndParameter.travelMixList == null || this.evaluationService.evaluationFrontEndParameter.travelMixList.length == 0) {
      return true;
    }

    // min selection must be 1 variant atleast
    if (this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters == undefined || this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters == null || this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.length == 0) {
      return true;
    }

    if (this.evaluationService.evaluationFrontEndParameter.graphicList == undefined || this.evaluationService.evaluationFrontEndParameter.graphicList == null || this.evaluationService.evaluationFrontEndParameter.graphicList.length == 0) {
      return true;
    }

    let result = this.evaluationService.companyGraphicSettings.settings.filter(e => {
      let res = (this.evaluationService.evaluationFrontEndParameter.graphicList.includes(e.graphicId)) && e.algorithmId == 2;
      return res;
    }).length > 0;

    // when a passenger exchange graphic was selected there has to be atleast one door selected
    if (result) {
      let res = (this.evaluationService.evaluationFrontEndParameter.trainEvaluationParameters.filter(x => x.doors.length > 0).length > 0);
      if (!res) {
        return true;
      }
    }

    if (this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personsBoardingDefault === null ||
      this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personsBoardingDefault < 0) {
      return true;
    }
    if (this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personsDeboardingDefault === null ||
      this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personsDeboardingDefault < 0) {
      return true;
    }

    if (this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personValueFormatId === 1) {

      if (this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personsBoardingDefault > 100) {
        return true;
      }

      if (this.evaluationService.evaluationFrontEndParameter.advancedSettings.default.personsDeboardingDefault > 100) {
        return true;
      }
    }

    return disabled;
  }

  evaluate() {
    this.requestService.evaluateTrain(this.evaluationService.evaluationFrontEndParameter)
      .subscribe((resp: HttpResponse<Blob>) => {
        downloadFile(resp.body, resp.headers.get('Content-Disposition'));
      });
  }

  canDeactivate() {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: this.backButtonModalMessage,
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Leave'
      }
    });
    return WaitForModalResult(dialogRef);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}